import { getPackageAddOnHref } from "app/common/hrefs";

interface IGoToAddonsPageParams {
    packageIds?: string[];
    presetId?: string;
}

const returnUrlParam = "returnUrl";
const packageIdParam = "packageId";
const presetIdParam = "presetId";

export function goToAddonsPage(params: IGoToAddonsPageParams = {}): void {
    const { packageIds, presetId } = params;
    let url = `${getPackageAddOnHref()}`;

    const queryParams: string[] = [];

    queryParams.push(`${returnUrlParam}=${encodeURIComponent(location.href)}`);

    if (packageIds) {
        queryParams.push(packageIds.map((packageName) => `${packageIdParam}=${packageName}`).join("&"));
    }

    if (presetId) {
        queryParams.push(`${presetIdParam}=${presetId.toString()}`);
    }

    if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
    }

    window.open(url);
}
